import { FormSketchInterface } from "@mitechnologies/formitize-2.5-canvas";
import React from "react";
import { lazy, Suspense } from "react";

const FormSketchModule = lazy(() => import("./form-sketch"));

export default function FormSketchLoader({
    onSaveInvoked,
    onExitInvoked,
    onMount,
    formSketchData,
    width = 1024,
    height = 1024,
    displayGrid = true,
    ...rest
} : {
    onSaveInvoked: (formSketch: FormSketchInterface) => void,
    onExitInvoked: (changes) => Promise<void>,
    onMount: (formSketch: FormSketchInterface) => void,
    formSketchData: any,
    width?: number,
    height?: number,
    displayGrid?: boolean
}) {
    return (<Suspense fallback={<div style={{
        position: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        top: 0,
        left: 0,
    }}>Loading...</div>}>
        <FormSketchModule 
            width={width}
            displayGrid={displayGrid}
            height={height}
            onSaveInvoked={onSaveInvoked}
            onExitInvoked={onExitInvoked}
            formSketchData={formSketchData}
            onMount={onMount}
            {...rest}
        />
    </Suspense>);
}